import superagent from 'superagent'

const Merchant = {
  submit: (card, pin, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .put(`${__API_URI__}/MerchantCard/Update/${card}/${pin}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            if (err.status === 404) {
              return reject('Invalid Card or Pin')
            } else {
              return reject(err.response.text)
            }
          }
          resolve(res.body)
        })
    })
  },
  get: (card, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .get(`${__API_URI__}/MerchantCard/Get/${card}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            if (err.status === 404) {
              return reject('Invalid Card or Pin')
            } else {
              return reject(err.response.text)
            }
          }
          resolve(res.body)
        })
    })
  }
}

export default Merchant